(function () {
  'use strict';

  const DESKTOP_BREAKPOINT = 1000;

  function closeMenuDrawer() {
    const drawer = document.getElementById('menu-drawer');
    if (drawer && drawer.open) {
      drawer.hide();
    }
  }

  function onResize() {
    if (window.innerWidth >= DESKTOP_BREAKPOINT) {
      closeMenuDrawer();
    }
  }

  const resizeObserver = new ResizeObserver(onResize);
  resizeObserver.observe(document.documentElement);
})();
